import React, { FC } from 'react';
import { Sailing, SailingDay, SailingDetails } from '../../shared/types/sailing';
import { SailingDay as SailingDayComponent } from '.';
import { range } from '../../shared/lib/functional';

import { isoDate, today } from '../../shared/lib/time';

import { Dropdown, Button } from '@spark-labs/avocado-ui';
import { DropdownItem } from '@spark-labs/avocado-ui/dist/components/Dropdown';
export interface SailingTableProps {
  sailing: Sailing;
  sailingDetails?: SailingDetails;
  columnWidths: number[];
  showAdminControls: boolean;
  onSailingDayStar?: (sailing: Sailing, sailingDay: SailingDay) => void;
  onSailingDayLock?: (sailing: Sailing, sailingDay: SailingDay) => void;
  onSailingDayTemplateClick?: (sailing: Sailing, sailingDay: SailingDay) => void;
  onAction?: (action: DropdownItem) => void;
  onRundownClick?: (sailing: Sailing, sailingDay: SailingDay) => void;
  onContentBuilderClick?: (sailing: Sailing, sailingDay: SailingDay) => void;
}

const SailingTable: FC<SailingTableProps> = ({
  sailing,
  sailingDetails,
  columnWidths,
  showAdminControls,
  onSailingDayStar,
  onSailingDayLock,
  onSailingDayTemplateClick,
  onAction,
  onRundownClick,
  onContentBuilderClick,
}) => {
  let dropdownItems = [
    { key: 'edit', element: 'Edit Sailing' },
    { key: 'apply', element: 'Apply Template' },
    { key: 'save', element: 'Save Sailing to Favorites' },
  ];

  return (
    <div>
      <table className="w-full border border-color-grey table-fixed">
        <thead>
          <tr>
            {range(columnWidths.length).map(i => (
              <th key={i} className="m-0 p-0" style={{ height: 0, width: columnWidths[i] + '%' }} />
            ))}
          </tr>
        </thead>
        <tbody>
          {sailing.days.map((day, i) => {
            let details = sailingDetails
              ? sailingDetails.dayDetails.find(d => d.sailingDayId === day._id)
              : undefined;
            return (
              <SailingDayComponent
                propertyId={sailing.property._id}
                sailingId={sailing._id}
                showAdminControls={showAdminControls}
                key={day._id}
                day={day}
                conflicts={details ? details.conflicts : []}
                currentDay={today() === isoDate(day.date)}
                parity={i % 2 === 0 ? 'even' : 'odd'}
                onSailingDayStar={
                  onSailingDayStar ? () => onSailingDayStar(sailing, day) : undefined
                }
                onSailingDayLock={
                  onSailingDayLock ? () => onSailingDayLock(sailing, day) : undefined
                }
                onSailingDayTemplateClick={
                  onSailingDayTemplateClick
                    ? () => onSailingDayTemplateClick(sailing, day)
                    : undefined
                }
                onRundownClick={onRundownClick ? () => onRundownClick(sailing, day) : undefined}
                onContentBuilderClick={
                  onContentBuilderClick ? () => onContentBuilderClick(sailing, day) : undefined
                }
              />
            );
          })}
        </tbody>
      </table>
      {showAdminControls && (
        <div className="flex flex-row-reverse">
          <Dropdown items={dropdownItems} onSelect={onAction} alignRight>
            {dropdownProps => (
              <Button
                ref={dropdownProps.toggleRef}
                className="bg-grey hover:bg-grey-light active:bg-grey pl-4 pr-2 focus:outline-none"
                {...dropdownProps}
              >
                <span className="text-white text-2xl -mt-4 inline-block">...</span>
              </Button>
            )}
          </Dropdown>
        </div>
      )}
    </div>
  );
};

export default SailingTable;
